import * as Yup from "yup";
import httpClient from "../config/HttpClient";
import EntityId from "../EntityId";
import { translations } from "../../../translations/common";

const SUBJECT_URL = "/users/subjects";

export interface SubjectData {
  id?: string;
  subject: string;
}

export const defaultSubjectData: Readonly<SubjectData> = {
  id: undefined,
  subject: "",
};

export const subjectSchema = Yup.object().shape({
  subject: Yup.string().required(translations.subjects.form.validation.subjectRequired),
});

export class SubjectModel {
  static async updateOrCreate(model: SubjectData): Promise<EntityId> {
    const url = model.id ? `${SUBJECT_URL}/${model.id}` : SUBJECT_URL;
    const method = model.id ? httpClient.put : httpClient.post;
    const response = await method<EntityId>(url, model);
    return response.data;
  }

  static async listAll(): Promise<SubjectData[]> {
    const response = await httpClient.get<SubjectData[]>(SUBJECT_URL);
    return response.data;
  }

  static async findOne(id: string): Promise<SubjectData> {
    const response = await httpClient.get<SubjectData>(`${SUBJECT_URL}/${id}`);
    return response.data;
  }

  static async delete(id: string): Promise<void> {
    await httpClient.delete(`${SUBJECT_URL}/${id}`);
  }
}

export default SubjectModel;
